import React, { FC } from "react";
import { useQuery } from "react-query";
import { IStatisticsFilter } from "../types";
import useStatisticsQueries from "../hooks/useStatisticsQueries";
import { parseToCountryStatisticsModel } from "../helpers/helperFunctions";
import { IPieChartSegment } from "../../../components/PieChart/types";
import PieChartWidget from "../../../components/PieChart";

interface ICountryWidgetProps {
  filter: IStatisticsFilter;
}

export const CountryWidget: FC<ICountryWidgetProps> = ({ filter }) => {
  const { fetchByCountry } = useStatisticsQueries();

  const { isLoading, data } = useQuery<IPieChartSegment[]>(
    `countryStatistics${JSON.stringify(filter)}`,
    async () => {
      const data = await fetchByCountry(filter);
      return parseToCountryStatisticsModel(data.data);
    },
  );

  return (
    <PieChartWidget
      isLoading={isLoading}
      data={data || []}
      title="Distribution by countries"
    />
  );
};
